// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__MWkwD","title":"ClientReferral_title__1j9fp","itemText":"ClientReferral_itemText__OjQSI"};